
export default {
  install(Vue) {
    Vue.prototype._APP_ = _APP_;
  }
};
